import { createSlice } from "@reduxjs/toolkit";

export const createAuthDataSlice = () => {
  const authDataSlice = createSlice({
    name: "authData",
    initialState: {
      type: "STUDENT",
      email: "",
      firstName: "",
      lastName: "",
      dob: "",
      gender: "",
      mobile: "",
      profile_photo: null,
      profile_type: "",
      password: "",
      edu_email: "",
      institute: "",
      department: "",
      academicTitle: "",
      yearLevel: "",
      researchArea: [],
    },
    reducers: {
      setAuthData: (state, action) => {
        return action.payload;
      },
      resetAuthData: (state) => {
        return {
          type: "STUDENT",
          email: "",
          firstName: "",
          lastName: "",
          dob: "",
          gender: "",
          mobile: "",
          profile_photo: null,
          profile_type: "",
          password: "",
          edu_email: "",
          institute: "",
          department: "",
          academicTitle: "",
          yearLevel: "",
          researchArea: [],
        };
      },
    },
  });

  return authDataSlice;
};
